import RoundButton from '@deltek/specification-client/core/Buttons/RoundButton'
import { ListingLevel } from '@deltek/specification-client/core/Models/product'
import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { navigateToExternalLink } from '@deltek/specification-client/core/Utilities/urlUtils'
import { makeStyles, Theme } from '@material-ui/core/styles'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import Typography from '@material-ui/core/Typography'
import clsx from 'clsx'
import React from 'react'

interface ViewDocumentRowStyleProps {
    disabled?: boolean
}

const useStyles = makeStyles((theme: Theme) => ({
    fullWidth: {
        width: '100%',
    },
    itemContainer: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },

    tableWhiteText: {
        color: '#FFF',
        fontWeight: 400,
        fontSize: pxToRem(13),
    },
    tableRowText: {
        color: '#304959',
        fontWeight: 400,
        width: '100%',
        whiteSpace: 'nowrap',
        fontSize: pxToRem(14),
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    tableRowButton: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
    },
    itemLeftSide: { width: 30 },

    icon: {
        height: 30,
        width: 30,
    },
    downloadContainer: {
        '& button.MuiButton-contained': {
            backgroundColor: (props: ViewDocumentRowStyleProps) =>
                props.disabled ? 'rgba(0, 0, 0, 0.12)' : '#A78966',
            borderRadius: 100,
            padding: theme.spacing(0.625, 2.5),
            height: 25,
            width: 98,
        },
    },
    sizeSmall: {
        padding: theme.spacing(0.5, 0),
    },
}))

interface ViewDocumentRowProps {
    icon: 'shortform' | 'longform' | 'catalog'
    text: string
    level: ListingLevel
    title?: string
    link?: string
}

export const ViewDocumentRow: React.FC<ViewDocumentRowProps> = ({
    text,
    link,
}) => {
    const classes = useStyles({ disabled: !link })
    const key = text.replace(/\s/g, '')

    return (
        <TableRow key={key}>
            <TableCell className={classes.sizeSmall}>
                <GridContainer>
                    <GridContainer
                        item
                        alignItems="center"
                        justifyContent="flex-start"
                    >
                        <GridItem>
                            <Typography
                                variant="subtitle2"
                                className={clsx(
                                    'documentType',
                                    classes.tableRowText
                                )}
                            >
                                {text}
                            </Typography>
                        </GridItem>
                    </GridContainer>
                </GridContainer>
            </TableCell>
            <TableCell align="right" className={classes.downloadContainer}>
                <RoundButton
                    data-testid={`btn${key}`}
                    disabled={!link}
                    hasShadow={false}
                    borderColor="#A78966"
                    backgroundColor="#A78966"
                    borderRadius={100}
                    onClick={() => navigateToExternalLink(link!)}
                >
                    <Typography
                        variant="subtitle2"
                        className={clsx(
                            classes.tableWhiteText,
                            classes.tableRowButton
                        )}
                    >
                        Download
                    </Typography>
                </RoundButton>
            </TableCell>
        </TableRow>
    )
}
